import React, { useEffect } from 'react';
import { Form, Input, Button, Card, message, Spin, Divider } from 'antd';
import { UserOutlined, LockOutlined, GoogleOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const onFinish = async (values: { username: string; password: string }) => {
    try {
      setLoading(true);
      const success = await login(values.username, values.password);
      if (success) {
        navigate('/');
      }
    } catch (error) {
      message.error('Có lỗi xảy ra khi đăng nhập');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // TODO: Implement Google login
    message.info('Tính năng đang được phát triển');
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f0f2f5'
    }}>
      <Card style={{ width: 300, boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
        <Spin spinning={loading}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h2>Mew Trader</h2>
            <p style={{ color: '#666' }}>Đăng nhập để tiếp tục</p>
          </div>
          <Form
            form={form}
            name="login"
            onFinish={onFinish}
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: 'Vui lòng nhập tên đăng nhập!' },
                { min: 3, message: 'Tên đăng nhập phải có ít nhất 3 ký tự!' }
              ]}
            >
              <Input 
                prefix={<UserOutlined />} 
                placeholder="Tên đăng nhập" 
                size="large"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'Vui lòng nhập mật khẩu!' },
                { min: 6, message: 'Mật khẩu phải có ít nhất 6 ký tự!' }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Mật khẩu"
                size="large"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                block 
                size="large"
                loading={loading}
              >
                Đăng nhập
              </Button>
            </Form.Item>

            <Divider>Hoặc</Divider>

            <Button
              icon={<GoogleOutlined />}
              block
              size="large"
              onClick={handleGoogleLogin}
              style={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              Đăng nhập với Google
            </Button>

            <div style={{ textAlign: 'center', marginTop: 16 }}>
              Chưa có tài khoản?{' '}
              <Button type="link" onClick={() => navigate('/register')} style={{ padding: 0 }}>
                Đăng ký
              </Button>
            </div>
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default Login;
